/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_DescriptionInputs */

const de_billing_invoices_description = /** @type {(inputs: Billing_Invoices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier finden Sie eine Übersicht Ihrer Rechnungen und können diese als PDF herunterladen.`)
};

/** @type {(inputs: Billing_Invoices_DescriptionInputs) => LocalizedString} */
const en_billing_invoices_description = de_billing_invoices_description;

/**

* @param {Billing_Invoices_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoices_description = /** @type {((inputs?: Billing_Invoices_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_invoices_description(inputs)
	return en_billing_invoices_description(inputs)
});